export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <a href="#hero" className="flex items-center gap-2.5 mb-4">
                <span className="w-9 h-9 flex items-center justify-center bg-accent-500 text-background-50 rounded-lg text-sm font-bold">蘑</span>
                <span className="text-lg font-heading font-bold text-background-50">蘑菇影院</span>
              </a>
              <p className="text-sm text-background-300 leading-relaxed">
                蘑菇影院致力于为广大影视爱好者提供高清流畅的在线观影体验。海量电影电视剧资源每日更新，让您随时随地畅享高清影视盛宴。
              </p>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h3>
              <ul className="space-y-2.5">
                <li><a href="#hero" className="text-sm text-background-300 hover:text-accent-400 transition-colors">首页</a></li>
                <li><a href="#index" className="text-sm text-background-300 hover:text-accent-400 transition-colors">分类索引</a></li>
                <li><a href="#media" className="text-sm text-background-300 hover:text-accent-400 transition-colors">精选推荐</a></li>
                <li><a href="#carousel" className="text-sm text-background-300 hover:text-accent-400 transition-colors">焦点专题</a></li>
                <li><a href="#faq" className="text-sm text-background-300 hover:text-accent-400 transition-colors">常见问题</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">热门分类</h3>
              <ul className="space-y-2.5">
                <li><span className="text-sm text-background-300">高清电影在线</span></li>
                <li><span className="text-sm text-background-300">高清电视剧全集</span></li>
                <li><span className="text-sm text-background-300">最新高清电影</span></li>
                <li><span className="text-sm text-background-300">热门综艺精选</span></li>
                <li><span className="text-sm text-background-300">动漫高清专区</span></li>
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">合作伙伴</h3>
              <p className="text-sm text-background-400">暂无合作伙伴信息</p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 蘑菇影院。本站所有资源来源于网络，仅供学习和交流使用。
            </p>
            <p className="text-xs text-background-400">
              高清电影在线 | 高清电视剧全集 | 流畅不卡顿
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}